'use client';

import dynamic from 'next/dynamic';
import { type PropsWithChildren } from 'react';
const LoadingBar = dynamic(() => import('./loading-bar'));

export interface ClientProviderParams {}
export const ClientProvider = ({
  children,
}: PropsWithChildren<ClientProviderParams>) => {
  return (
    <>
      {children}
      <LoadingBar></LoadingBar>
    </>
  );
};
